<!-- 数据需求信息 -->
<template>
  <div class="data-info-wrap">
    <div
      class="data_info"
      ref="swipe"
      @scroll.passive="onSwipeScroll"
    >
      <div
        v-for="(item, index) in datalist"
        :key="index"
        class="item-box gs-card"
      >
        <div class="card-head">
          <div class="card-brand hand-cursor" @click="titleClickBtn(item)">
            <img :src="getIconPath(item.icon)" class="item-icon" alt="" />
            <span class="card-title hover-red">{{ item.title }}</span>
          </div>
          <span class="btn hand-cursor-btn" @click="applyTitleClickBtn(item)">
            <span class="btn-full">{{ item.applyTitle }}</span>
            <span class="btn-short">{{ shortApply(item) }}</span>
          </span>
        </div>
        <div class="child-line">
          <GsSkeleton v-if="loading" :rows="3" />
          <div v-else-if="item.list && item.list.length < 1">
            <no-data />
          </div>
          <div v-else>
            <div
              v-for="(itemChild, indexChild) in item.list"
              :key="indexChild"
              class="list-row hand-cursor hover-tr"
              @click="titleClickBtnRow(item, itemChild)"
            >
              <div class="little-title">
                <div class="name-text name-full">{{ rowName(item, itemChild) }}</div>
                <div class="name-text name-short" :title="rowName(item, itemChild)">{{ shortName(item, itemChild) }}</div>
              </div>
              <div class="ellipsis-one text-content" v-if="item.type !==3">{{  transFormEnum(labelList, itemChild.businessType) }}</div>
              <div class="ellipsis-one text-content is-desc" v-if="item.type !== 3" :title="rowBrief(item, itemChild)">
                {{ rowBrief(item, itemChild) }}
              </div>
              <div class="ellipsis-one text-content" v-if="item.type === 3" :title="itemChild.dataTradingWeb">
                {{ itemChild.dataTradingWeb }}
              </div>
              <div class="ellipsis-one text-content is-desc" v-if="item.type === 3" :title="itemChild.tradingCenterIntroduction">
                {{ itemChild.tradingCenterIntroduction }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="swipe-dots" aria-hidden="true">
      <button
        v-for="(item, index) in datalist"
        :key="'dot-' + index"
        type="button"
        class="swipe-dot"
        :class="{ on: swipeIndex === index }"
        @click="scrollToCard(index)"
      />
    </div>
  </div>
</template>
<script>
import { getListingList, dataTradingList } from '@/api/Home/index.js'
import { getDataType } from '@/api/Layout/index.js'
import {enumType} from '@/utils/enum.js'
import NoData from '@/components/NoData/index.vue'
import { P } from '@/router/paths'
export default {
  name: 'dataInfoLeft',
  components: { NoData },
  data(){
    return {
      labelList: [],
      loading: true,
      swipeIndex: 0,
      datalist:[
        {
            title: '数据需求方',
            applyTitle: '数据需求申请',
            type: 1,
            icon:'编组 8@2x.png',
            list:[]
        },
        {
            title: '数据服务商',
            applyTitle: '数据服务登记',
            type: 2,
            icon:'编组 8@2x(1).png',
            list:[]
        },
        {
            title: '数据交易所',
            applyTitle: '数据交易所申请',
            type: 3,
            icon:'编组 8@2x copy.png',
            list:[]
        }
      ]
    }
  },
  computed: {
    transFormEnum () {
      return function (enumList, value, multi) {
        if(value) {
          let valObj = []
          if(multi) {
            valObj = JSON.parse(value)
          } else {
            valObj = value.split(',').map(item => item.trim())
          }
          let labelListEnum = []
          if(enumList && enumList.length > 0) {
            enumList.forEach(item => {
              valObj && valObj.forEach(itemObj => {
                if(itemObj === item.value) {
                  labelListEnum.push(item.label)
                }
              })
            })
          }
          return labelListEnum.join(',')
        } else {
          return ''
        }
      }
    }
  },
  created() {
    this.initData()
    this.getData('sys_business_type')
  },
  methods:{
    getIconPath (iconName) {
      return require(`@/assets/images/${iconName}`);
    },
    shortApply(item) {
      if (item.type === 2) return '登记'
      return '申请'
    },
    rowName(item, child) {
      if (!child) return ''
      return item.type === 3 ? (child.dataTradingFull || child.name || '') : (child.companyName || child.name || '')
    },
    rowBrief(item, child) {
      if (!child) return ''
      const text = child.requireMent || child.requirement || ''
      if (text) return text
      return item.type === 1 ? (child.dataRequirement || '') : ''
    },
    shortName(item, child) {
      return this.rowName(item, child)
        .replace(/股份有限公司$/, '')
        .replace(/有限责任公司$/, '')
        .replace(/有限公司$/, '')
    },
    onSwipeScroll() {
      const el = this.$refs.swipe
      if (!el || !el.children || !el.children.length) return
      const card = el.children[0]
      const step = card.offsetWidth + 12
      if (!step) return
      const idx = Math.round(el.scrollLeft / step)
      this.swipeIndex = Math.max(0, Math.min(idx, this.datalist.length - 1))
    },
    scrollToCard(index) {
      const el = this.$refs.swipe
      if (!el || !el.children || !el.children[index]) return
      el.children[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' })
      this.swipeIndex = index
    },
    // 枚举
    async getData(type) {
      try {
        const res = await getDataType(type);
        if (res && res.data && res.data.length > 0) {
          if(type === 'sys_business_type') {
            this.labelList = enumType(res.data)
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error)
      }
    },
    // 列表数据
    initData() {
      const page = { pageNum: 1, pageSize: 3, whetherPublish: '1' }
      Promise.all([
        getListingList({ ...page, listingType: '6' }),
        getListingList({ ...page, listingType: '5' }),
        dataTradingList({
          currentPage: 1,
          pageSize: 3,
          administrativeDivisionCode: '',
          whetherPublish: '1'
        })
      ]).then(([demand, provider, trading]) => {
        this.datalist[0].list = ((demand && demand.rows) || []).slice(0, 3)
        this.datalist[1].list = ((provider && provider.rows) || []).slice(0, 3)
        const rows = (trading && trading.rows) || []
        rows.forEach(itemTrad => {
          itemTrad.name = itemTrad.dataTradingFull
        })
        this.datalist[2].list = rows
      }).catch(() => {}).finally(() => {
        this.loading = false
      })
    },
    titleClickBtn(item) {
      if(item.type === 1) this.$router.push(P.demand)
      else if (item.type === 2) this.$router.push(P.providers)
      else this.$router.push(P.exchanges)
    },
    titleClickBtnRow(item, itemChild) {
      if (item.type === 1) this.$router.push(P.listingDetail(itemChild.id, 'demand'))
      else if (item.type === 2) this.$router.push(P.listingDetail(itemChild.id, 'provider'))
      else this.$router.push(P.exchanges)
    },
    applyTitleClickBtn(item) {
      if(item.type === 3) this.$router.push(P.exchangeApply)
      else if(item.type === 2) this.$router.push(P.providerApply)
      else this.$router.push(P.demandApply)
    }
  }
}
</script>
<style lang="less" scoped>
.data_info{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
  height: 100%;
}
.item-box {
  flex: 1;
  width: 33%;
  min-width: 0;
  height: 267px;
  display: flex;
  flex-direction: column;
  background: linear-gradient( 180deg, rgba(152,195,255,0.94) 0%, rgba(245,248,251,0) 100%);
  border-radius: 8px;
  opacity: 0.92;
  backdrop-filter: blur(8px);
  padding: 30px 20px;
  box-sizing: border-box;
}
.card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}
.card-brand {
  display: flex;
  align-items: center;
  min-width: 0;
}
.card-title {
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
  color: #111824;
}
.btn-short {
  display: none;
}
.list-row {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 0.9fr) minmax(0, 1.45fr);
  align-items: center;
  column-gap: 12px;
  min-width: 0;
  min-height: 36px;
}
.little-title {
  font-family: AlibabaPuHuiTi_3_65_Medium;
  font-size: 16px;
  color: #0165FF;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  min-width: 0;
}
.name-text {
  max-width: none;
  padding-right: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.name-short {
  display: none;
}
.text-content {
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 16px;
  color: #5E6166;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-content.is-desc {
  padding-right: 0;
}
.item-icon {
  width: 40px;
  height: 40px;
  display: block;
  margin-right: 10px;
  flex-shrink: 0;
}
.child-line {
  flex: 1;
  min-height: 120px;
  background: linear-gradient( 180deg, #FFFFFF 0%, rgba(255,255,255,0) 100%);
  border-radius: 8px;
  padding: 16px;
}
.btn {
  width: 140px;
  height: 30px;
  flex-shrink: 0;
  background: linear-gradient( 263deg, #428DFF 0%, #0062F9 100%);
  box-shadow: 2px 2px 4px 0px rgba(0,107,206,0.3);
  border-radius: 15px;
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 30px;
  text-align: center;
  font-style: normal;
}
.hover-red:hover {
  color: #ff0000;
}
.hover-tr:hover {
  background-color: #EBEEF5;
}
.hand-cursor-btn:hover {
  background: #FFFFFF;
  color: #0062F9;
  cursor: pointer;
}
@media (max-width: 960px) {
  .data-info-wrap {
    width: 100%;
  }
  .data_info {
    --card-w: calc(100vw - 56px);
    display: flex;
    flex-direction: row;
    align-items: stretch;
    gap: 12px;
    width: auto;
    margin: 0 calc(var(--home-pad, 10px) * -1);
    padding: 0 calc((100vw - var(--card-w)) / 2) 2px;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-snap-type: x mandatory;
    scroll-padding-inline: calc((100vw - var(--card-w)) / 2);
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .data_info::-webkit-scrollbar {
    display: none;
  }
  .item-box {
    flex: 0 0 var(--card-w);
    width: var(--card-w);
    max-width: none;
    height: auto;
    min-height: 0;
    padding: 10px 10px 8px;
    opacity: 1;
    scroll-snap-align: center;
    overflow: hidden;
    border-radius: 12px;
  }
  .item-box:hover {
    transform: none;
    box-shadow: none;
  }
  .card-head {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    margin-bottom: 6px;
    gap: 6px;
  }
  .card-brand {
    justify-content: flex-start;
    gap: 6px;
    min-width: 0;
  }
  .item-icon {
    width: 24px;
    height: 24px;
    margin-right: 0;
  }
  .card-title {
    font-size: 14px;
    font-weight: 700;
    line-height: 1.2;
    text-align: left;
  }
  .btn-full {
    display: none;
  }
  .btn-short {
    display: inline;
  }
  .btn {
    width: auto;
    min-width: 48px;
    padding: 0 10px;
    height: 26px;
    line-height: 26px;
    border-radius: 13px;
    font-size: 12px;
    box-shadow: none;
    flex-shrink: 0;
  }
  .child-line {
    flex: none;
    min-height: 0;
    padding: 4px 8px;
    background: rgba(255, 255, 255, 0.94);
    border-radius: 8px;
    overflow: hidden;
  }
  .list-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    column-gap: 6px;
    padding: 5px 0;
    border-radius: 4px;
    min-height: 0;
  }
  .list-row + .list-row {
    border-top: 1px solid rgba(1, 101, 255, 0.08);
  }
  .child-line .text-content {
    display: block;
    font-size: 11px;
    line-height: 16px;
  }
  .child-line .text-content.is-desc {
    display: none;
  }
  .little-title {
    width: auto;
    font-size: 12px;
    line-height: 1.3;
    text-align: left;
  }
  .name-text {
    max-width: 100%;
    padding-right: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .name-full {
    display: none;
  }
  .name-short {
    display: block;
  }
  .swipe-dots {
    display: flex;
    justify-content: center;
    gap: 6px;
    margin-top: 8px;
  }
  .swipe-dot {
    width: 6px;
    height: 6px;
    padding: 0;
    border: 0;
    border-radius: 999px;
    background: rgba(1, 101, 255, 0.22);
    cursor: pointer;
  }
  .swipe-dot.on {
    width: 16px;
    background: #0165ff;
  }
}
@media (min-width: 961px) {
  .swipe-dots {
    display: none;
  }
}
</style>